class MiniCart extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        // Initialize bulk inquiry functionality for cart items after content loads
        this.initializeBulkInquiryForCart();
        
        // Sync cart quantities with product forms
        setTimeout(() => {
          if (typeof syncCartQuantityWithProductForms === 'function') {
            syncCartQuantityWithProductForms();
          }
        }, 200);

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }
  open() {
    // Check if bulk inquiry limit has been reached and prevent opening
    if (document.body.classList.contains('bulk-inquiry-limit-reached')) {
      console.log('Cart drawer opening prevented due to bulk inquiry limit');
      return;
    }

    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }
  renderContents(parsedState) {
    // Check if bulk inquiry limit has been reached and prevent opening
    if (document.body.classList.contains('bulk-inquiry-limit-reached')) {
      console.log('Cart drawer rendering prevented due to bulk inquiry limit');
      return;
    }

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    // Initialize bulk inquiry functionality for cart items after content updates
    this.initializeBulkInquiryForCart();
    
    // Sync cart quantities with product forms
    setTimeout(() => {
      if (typeof syncCartQuantityWithProductForms === 'function') {
        syncCartQuantityWithProductForms();
      }
    }, 200);

    this.open();
  }
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  initializeBulkInquiryForCart() {
    // Find ALL cart items (not just bulk inquiry ones)
    const allCartItems = document.querySelectorAll('.mini-cart__navigation li[data-variant-id]');

    allCartItems.forEach(cartItem => {
      const quantityInput = cartItem.querySelector('quantity-input');
      const input = cartItem.querySelector('quantity-input input');
      const plusButton = cartItem.querySelector('.quantity__button[name="plus"]');

      if (!quantityInput || !input || !plusButton) return;

      // Check if THIS SPECIFIC cart item has bulk inquiry attribute
      const isBulkInquiryProduct = quantityInput.hasAttribute('data-bulk-inquiry') && 
                                  quantityInput.getAttribute('data-bulk-inquiry') === 'true';

      if (isBulkInquiryProduct) {
        // Apply bulk inquiry restrictions ONLY to this specific product
        
        // Ensure max value is set to 2 for THIS bulk inquiry product only
        if (parseInt(input.value) > 2) {
          input.value = 2;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Set max attribute ONLY for THIS bulk inquiry product
        input.setAttribute('max', '2');
        input.setAttribute('data-max', '2');

        // Disable plus button if quantity is already 2 for THIS product
        if (parseInt(input.value) >= 2) {
          plusButton.classList.add('disabled');
        } else {
          plusButton.classList.remove('disabled');
        }
      } else {
        // For NON-bulk inquiry products, ensure they don't have bulk inquiry restrictions
        
        // Remove any accidentally applied bulk inquiry max limits
        if (input.getAttribute('max') === '2' && !input.hasAttribute('data-original-max')) {
          // Check if there was an original max from quantity rules
          const originalMax = input.getAttribute('data-max');
          if (originalMax && originalMax !== '2') {
            input.setAttribute('max', originalMax);
          } else {
            // Remove the max attribute if it was only set by bulk inquiry logic
            input.removeAttribute('max');
          }
        }

        // Re-enable plus button for non-bulk inquiry products (unless they hit their own limits)
        const currentValue = parseInt(input.value);
        const maxValue = input.getAttribute('max');
        
        if (maxValue && currentValue >= parseInt(maxValue)) {
          plusButton.classList.add('disabled');
        } else {
          plusButton.classList.remove('disabled');
        }
      }
    });
  }
}
customElements.define('mini-cart', MiniCart);